import * as UI from "@iyk/ui"

export const Footer = () => {
  return (
    <footer className="flex flex-col gap-24 px-4 pt-24 pb-4">
      <div className="flex flex-col">
        {FOOTER_LINKS.map((link, idx) => (
          <a
            key={idx}
            href={link.href}
            className="text-sm text-gray-12 py-2.5 [&:not(:last-child)]:bshadow-b [&:not(:last-child)]:bshadow-gray-4 flex items-center justify-between"
            target="_blank"
            rel="noreferrer"
          >
            <div className="flex items-center gap-2">
              <link.logo />
              {link.label}
            </div>
            <UI.Icon.ArrowUpRight />
          </a>
        ))}
      </div>
      <a
        href="https://iyk.app"
        className="text-xs-upper text-gray-10"
        target="_blank"
        rel="noreferrer"
      >
        Powered by IYK
      </a>
    </footer>
  )
}

const FOOTER_LINKS = [
  {
    label: "Facebook",
    logo: UI.Icon.Facebook,
    href: "https://www.facebook.com/danielallanmusic/",
  },
  {
    label: "Instagram",
    logo: UI.Icon.Instagram,
    href: "https://www.instagram.com/danielallanmusic/",
  },
  {
    label: "YouTube",
    logo: UI.Icon.Youtube,
    href: "https://www.youtube.com/channel/UCAgx_ylMQtouOWjmuQAO7Qg",
  },
  {
    label: "X",
    logo: UI.Icon.X,
    href: "https://x.com/imdanielallan",
  },
  {
    label: "Spotify",
    logo: UI.Icon.Spotify,
    href: "https://open.spotify.com/artist/5JQ1XqKJ2Art01rF4tu1Ra",
  },
  {
    label: "Soundcloud",
    logo: UI.Icon.Soundcloud,
    href: "https://soundcloud.com/danielallantunes",
  },
  {
    label: "TikTok",
    logo: UI.Icon.Tiktok,
    href: "https://www.tiktok.com/@danielallanmusic",
  },
]
